import { useEffect, useRef, useState } from "react";
import VisualizerColorsPdp from "./VisualizerColorsPdp";
export default function PdpVisualizerPopup({
  products,
  product,
  visualizerType,
}) {
  const [currentProduct, setCurrentProduct] = useState(product.sku);
  const visRef = useRef(null);
  const visualizerInstance = useRef(null);
  const siteInfo = window.wpProductFilter?.siteInfo;
  const primaryColor = siteInfo?.primaryColor;
  const secondaryColor = siteInfo?.secondaryColor;
  const domainApiKey = siteInfo?.domainApiKey;

  const productIds = products
    .filter((item) => item.upid !== "")
    .map((item) => `${item.upid}`);

  useEffect(() => {
    // Load external script only once

    if (domainApiKey !== undefined && domainApiKey !== "") {
      const script = document.createElement("script");
      script.src = "https://viz.broadlu.me/dist/visualiserLoader_v2.9.js";
      script.async = true;
      script.onload = () => {
        if (window.visualiserLoader) {
          let config = {
            download: true,
            product: product.upid,
            bgcolor: "#221E20",
            activebgcolor: "#747474",
            fontcolor: "#FFFDF8",
            accent: primaryColor ?? "#A52F76",
            accentfontcolor: "#ffffff",
            loadingmessage: "Loading a fantastic visualizer, hold tight!...",
            loadingcolor: primaryColor ?? "#ff00ff",
          };

          if (visualizerType === "collection") {
            config = { ...config, products: productIds };
          }
          if (visualizerType === "product") {
            config = { ...config, type: "sku" };
          }
          // console.log(config);
          visualizerInstance.current = new window.visualiserLoader(
            visRef.current.id,
            domainApiKey,
            { desktopHeightPercent: 75, desktopWidthPercent: 95 },
            config,
            true,
            false,
          );

          // visualizerInstance.current.addListener("allEvents", (data) => {
          //   console.log(
          //     "Event Received:",
          //     data.eventName,
          //     "Payload:",
          //     data.eventData
          //   );
          // });
        }
      };
      document.body.appendChild(script);

      // Cleanup (optional, removes script if component unmounts)
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [visualizerType]);

  const resetCurrentProduct = (item) => {
    setCurrentProduct(item.sku);
    if (visualizerInstance.current) {
      // send event to visualizer
      visualizerInstance.current.sendEvent("setProductBySKU", item.sku);
    }
  };
  useEffect(() => {
    if (window.location.hash === "#visualizer") {
      setTimeout(() => {
        const element = document.getElementById("visualizer");
        element.style.scrollMarginTop = "100px";
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, []);
  return (
    <>
      <div className="visualizerHeading" id="visualizer">
        <h2>See In My Room</h2>
        <h3>Transform your room in real-time by uploading a photo now</h3>
      </div>
      <div id="productVisualizer" ref={visRef}></div>
      {domainApiKey !== undefined &&
        domainApiKey !== "" &&
        visualizerType === "product" && (
          <div className="visualizerColorsWrap">
            <VisualizerColorsPdp
              products={products}
              currentProduct={currentProduct}
              width={35}
              height={35}
              resetCurrentProduct={resetCurrentProduct}
            />
          </div>
        )}
    </>
  );
}
